import { createRoute } from "@tanstack/react-router";

import { rootRoute } from "@app/router/rootRoute";
import { renderProtectedRoute } from "@app/router/routeElements";
import { lazyWithRetry } from "@shared/lib/lazy";

const posWorkspace = lazyWithRetry(() => import("./routes/index"));

const posRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/pos",
  component: () =>
    renderProtectedRoute(posWorkspace, {
      requirePerms: ["pos.access"],
      showTrialBanner: false,
      allowOfflineSession: true,
    }),
});

export const posRouteTree = [posRoute];
